module.exports = __webpack_public_path__ + "img/amazon-pay-logo.de548c06.svg";